import { useMutation } from "react-query";
import { checkUserId as checkUserIdReq } from "src/service/sessions";

interface IUseCheckUserIdProps {
  onSuccess?: () => void;
  onError?: () => void;
}
export function useCheckUserId({ onSuccess, onError }: IUseCheckUserIdProps) {
  const { mutateAsync: mutateCheckUserId } = useMutation(checkUserIdReq, {
    onSuccess,
    onError,
  });

  return { mutateCheckUserId };
}
